/* =====================================================================

   EE Shoppable Blog — Theme-seitige Bild-Map (Saeule B)

   Pflege: pro Artikel-Handle Liste von Bildern -> Produkt/Collection.

   "images": Body-Bilder (match=Zahl ODER alt-Teilstring).

   "featured": Titelbild/Hero (.article__image-wrapper) -> items[].

   Einzel-Eintrag: {match,type,handle,label}. Multi: {...,items:[{type,handle,label},...]}.

   Stand 17.06.2026: User-kuratiert, alle Handles live verifiziert (active+published).

   02.07.2026: Mojibake-Regression repariert (UTF-8-Rebuild), 3 neue Artikel-Keys, 2 Labels ausgeschrieben.

   ===================================================================== */

window.EE_SHOPPABLE_MAP = {
  "funkien-hosta-im-pflanzkubel-schattenpflanze": {
    "featured": [
      {
        "type": "collection",
        "handle": "rund-konisch",
        "label": "Rund-konische Kübel"
      }
    ]
  },
  "engelstrompete-im-kubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "zylinder",
        "label": "Zylinder-Kübel"
      }
    ]
  },
  "ilex-crenata-im-kubel-buchsbaum-ersatz-richtig-pflegen": {
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-quadratisch-40x40x40cm-perlmutt-weiss",
        "label": "Kübel 40x40 perlmutt-weiß"
      }
    ]
  },
  "hibiskus-im-kubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "pflanztrog",
        "label": "Pflanztröge"
      }
    ]
  },
  "dipladenia-im-pflanzkubel": {
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rund-konisch-d50xh50cm-perlmutt-weiss",
        "label": "Rund-konischer Kübel D50 weiß"
      }
    ]
  },
  "moderne-terrassengestaltung-pflanzkuebel": {
    "collection": "fiberglas",
    "images": [
      {
        "match": "Rechteckiger Pflanztrog",
        "type": "collection",
        "handle": "pflanzkubel-als-raumteiler",
        "label": "Als Raumteiler"
      },
      {
        "match": "konische Pflanzkübel",
        "type": "collection",
        "handle": "fiberglas",
        "label": "Fiberglas-Kübel"
      },
      {
        "match": "Solitär-Pflanzkübel",
        "type": "collection",
        "handle": "xxl",
        "label": "XXL-Solitärkübel"
      }
    ],
    "featured": [
      {
        "type": "collection",
        "handle": "konisch",
        "label": "Konisch"
      },
      {
        "type": "collection",
        "handle": "anthrazit-metallic",
        "label": "Anthrazit Metallic"
      }
    ]
  },
  "pflanzentrends-2026": {
    "images": [
      {
        "match": "Runder grauer Pf",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "pflanzschale",
            "label": "Pflanzschale"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      },
      {
        "match": "Hohe schwarze Pf",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "pflanzkubel-als-raumteiler",
            "label": "Pflanzkübel als Raumteiler"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-rechteckig-108x40x100cm-elegant-schwarz-matt",
            "label": "Pflanzkübel"
          }
        ]
      },
      {
        "match": "Schwarzer Pflanz",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "schwarz",
            "label": "Schwarz"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-rechteckig-60x25x30cm-schwarz-matt",
            "label": "Pflanzkübel"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "collection",
        "handle": "schwarz",
        "label": "Schwarz"
      },
      {
        "type": "collection",
        "handle": "quadratisch",
        "label": "Quadratisch"
      }
    ]
  },
  "mediterrane-terrasse-gestalten": {
    "images": [
      {
        "match": "Mediterrane Terr",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "rund-konisch",
            "label": "Rund Konisch"
          },
          {
            "type": "collection",
            "handle": "perlmuttweiss",
            "label": "Perlmuttweiß"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "collection",
        "handle": "schwarz",
        "label": "Schwarz"
      },
      {
        "type": "collection",
        "handle": "zylinder",
        "label": "Zylinder"
      }
    ]
  },
  "pflanzkuebel-anthrazit-ueberblick": {
    "images": [
      {
        "match": "Anthrazit metall",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-anthrazit-metallic-quadratisch-40x40x40cm",
            "label": "Pflanzkübel"
          }
        ]
      },
      {
        "match": "Anthrazitfarbene",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "pflanztrog",
            "label": "Pflanztrog"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-anthrazit-metallic-fiberglas-rechteckig-80x30x40cm",
            "label": "Pflanzkübel"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "collection",
        "handle": "anthrazit-metallic",
        "label": "Anthrazit Metallic"
      },
      {
        "type": "collection",
        "handle": "anthrazit-grau",
        "label": "Anthrazit Grau"
      }
    ]
  },
  "pflanzkuebel-landschaftsdesign-modern": {
    "images": [
      {
        "match": "Grosser grauer P",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-quadratisch-80x80x80cm-grau",
            "label": "Pflanzkübel"
          }
        ]
      },
      {
        "match": "Grosse graue rec",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-rechteckig-anthrazit-metallic-120x50x55cm",
            "label": "Pflanzkübel"
          },
          {
            "type": "collection",
            "handle": "pflanztrog",
            "label": "Pflanztrog"
          },
          {
            "type": "collection",
            "handle": "xxl",
            "label": "Pflanzkübel XXL"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "collection",
        "handle": "schwarz",
        "label": "Schwarz"
      },
      {
        "type": "collection",
        "handle": "quadratisch",
        "label": "Quadratisch"
      }
    ]
  },
  "pflanzkubel-in-betonoptik-moderner-industrial-look-mit-weniger-gewicht": {
    "images": [
      {
        "match": "Zwei würfelförmi",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-quadratisch-40x40x40cm-grau",
            "label": "Pflanzkübel"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "collection",
        "handle": "grau-wie-betongrau",
        "label": "Grau (wie Betongrau)"
      },
      {
        "type": "collection",
        "handle": "saule",
        "label": "Säule"
      }
    ]
  },
  "pflanzkubel-farben-wahlen-tipps-fur-terrasse-garten": {
    "images": [
      {
        "match": "Zwei würfelförmi",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-anthrazit-metallic-quadratisch-40x40x40cm",
            "label": "Pflanzkübel"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "collection",
        "handle": "saule",
        "label": "Säule"
      },
      {
        "type": "collection",
        "handle": "pflanzkubel-nach-farbe",
        "label": "Pflanzkübel nach Farbe"
      }
    ]
  },
  "pflanzkuebel-innen-wohnzimmer-flur-esszimmer": {
    "images": [
      {
        "match": "Schwarze Fibergl",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "schwarz",
            "label": "Schwarz"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-saule-30x30x68cm-elegant-schwarz-matt",
            "label": "Pflanzkübel"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-quadratisch-40x40x40cm-elegant-schwarz-matt",
            "label": "Pflanzkübel"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-saule-30x30x60cm-elegant-schwarz-matt",
            "label": "Pflanzkübel"
          }
        ]
      },
      {
        "match": "Rechteckiger ant",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "pflanzkubel-als-raumteiler",
            "label": "Pflanzkübel als Raumteiler"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-rechteckig-108x40x100cm-anthrazit-metallic",
            "label": "Pflanzkübel"
          }
        ]
      },
      {
        "match": "Perlmuttweiße Pf",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-schale-rund-d46xh16cm-perlmutt-weiss",
            "label": "Pflanzkübel"
          },
          {
            "type": "collection",
            "handle": "pflanzschale",
            "label": "Pflanzschale"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "collection",
        "handle": "schwarz",
        "label": "Schwarz"
      },
      {
        "type": "collection",
        "handle": "rund-konisch",
        "label": "Rund Konisch"
      }
    ]
  },
  "balkon-gestalten-mit-pflanzkuebeln": {
    "images": [
      {
        "match": "Schmaler Balkon mit vers",
        "type": "collection",
        "handle": "pflanztrog",
        "label": "Pflanztrog"
      },
      {
        "match": "Schmaler Balkon mit Bist",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "pflanzkubel-als-raumteiler",
            "label": "Pflanzkübel als Raumteiler"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-rechteckig-84x30x80cm-anthrazit-metallic",
            "label": "Pflanzkübel"
          }
        ]
      },
      {
        "match": "Schmaler Balkon mit durc",
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-120x50x55cm-elegant-schwarz-matt",
        "label": "Pflanzkübel"
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-80x30x40cm-perlmutt-weiss",
        "label": "Pflanzkübel"
      }
    ]
  },
  "eingangsbereich-gestalten-pflanzkuebel": {
    "images": [
      {
        "match": "Zwei schwarze ho",
        "type": "product",
        "handle": "pflanzkubel-fiberglas-saule-konisch-38x38x100cm-elegant-schwarz-matt",
        "label": "Pflanzkübel"
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-saule-konisch-38x38x100cm-hochglanz-weiss",
        "label": "Pflanzkübel"
      }
    ]
  },
  "bougainvillea-im-kubel": {
    "images": [
      {
        "match": "Drei Bougainvill",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-quadratisch-60x60x60cm-perlmutt-weiss",
            "label": "Pflanzkübel"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-anthrazit-metallic-quadratisch-50x50x50cm",
        "label": "Pflanzkübel"
      }
    ]
  },
  "areca-palme-im-pflanzkubel": {
    "images": [
      {
        "match": "Helles Nord-Ost-",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          },
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-anthrazit-metallic-quadratisch-60x60x60cm",
            "label": "Pflanzkübel"
          }
        ]
      },
      {
        "match": "Areca-Palme als ",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "rund-konisch",
            "label": "Rund Konisch"
          },
          {
            "type": "collection",
            "handle": "perlmuttweiss",
            "label": "Perlmuttweiß"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-quadratisch-50x50x50cm-perlmutt-weiss",
        "label": "Pflanzkübel"
      }
    ]
  },
  "bogenhanf-im-pflanzkubel": {
    "images": [
      {
        "match": "Bogenhanf in 30 ",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-anthrazit-metallic-quadratisch-50x50x50cm",
            "label": "Pflanzkübel"
          }
        ]
      },
      {
        "match": "Drei Bogenhanf-P",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "schwarz",
            "label": "Schwarz"
          },
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-quadratisch-30x30x30cm-elegant-schwarz-matt",
            "label": "Pflanzkübel"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-zylindrisch-d40xh40cm-perlmutt-weiss",
        "label": "Pflanzkübel"
      }
    ]
  },
  "kumquat-im-kuebel": {
    "images": [
      {
        "match": "Kumquat im helle",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "rund-konisch",
            "label": "Rund Konisch"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-rund-konisch-d60xh46-5cm-perlmutt-weiss",
            "label": "Pflanzkübel"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-quadratisch-40x40x40cm-perlmutt-weiss",
        "label": "Pflanzkübel"
      }
    ]
  },
  "sukkulenten-im-pflanzkubel": {
    "images": [
      {
        "match": "Grauer quadratis",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "niedrig-quadratisch",
            "label": "Niedrig-Quadratisch"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-niedrige-quadratisch-50x50x20cm-grau",
            "label": "Pflanzkübel"
          }
        ]
      },
      {
        "match": "Zwei schwarze Pf",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "pflanzschale",
            "label": "Pflanzschale"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-rund-d50xh25cm-elegant-schwarz-matt",
            "label": "Pflanzkübel"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-rechteckig-anthrazit-metallic-60x25x30cm",
        "label": "Pflanzkübel"
      }
    ]
  },
  "rosen-im-pflanzkuebel": {
    "images": [
      {
        "match": "Rotes Rosenstämm",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "saule",
            "label": "Säule"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-saule-30x30x60cm-anthrazit-metallic",
            "label": "Pflanzkübel"
          }
        ]
      },
      {
        "match": "Rose in Jutesack",
        "items": [
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-anthrazit-metallic-quadratisch-40x40x40cm",
            "label": "Pflanzkübel"
          },
          {
            "type": "collection",
            "handle": "pflanzkubel-frostsicher-und-winterfest",
            "label": "Pflanzkübel frostsicher und winterfest"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-quadratisch-50x50x50cm-perlmutt-weiss",
        "label": "Pflanzkübel"
      }
    ]
  },
  "zitronenbaum-im-kuebel-pflegen": {
    "images": [
      {
        "match": "Querschnitt eine",
        "type": "collection",
        "handle": "pflanzkubel-frostsicher-und-winterfest",
        "label": "Pflanzkübel frostsicher und winterfest"
      },
      {
        "match": "Zitronenbaum im ",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "rund-konisch",
            "label": "Rund Konisch"
          },
          {
            "type": "collection",
            "handle": "perlmuttweiss",
            "label": "Perlmuttweiß"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-anthrazit-metallic-quadratisch-50x50x50cm",
        "label": "Pflanzkübel"
      }
    ]
  },
  "gemuese-im-pflanzkuebel-anbauen": {
    "images": [
      {
        "match": "Salat und Kräute",
        "type": "product",
        "handle": "pflanzkubel-fiberglas-quadratisch-50x50x50cm-perlmutt-weiss",
        "label": "Pflanzkübel"
      },
      {
        "match": "Querschnitt eine",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "grau-wie-betongrau",
            "label": "Grau (wie Betongrau)"
          },
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-60x25x30cm-schwarz-matt",
        "label": "Pflanzkübel"
      }
    ]
  },
  "rhododendron-im-kubel-standort-erde-richtige-kubelgrosse": {
    "images": [
      {
        "match": "Pflanze wird in ",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "rund-konisch",
            "label": "Rund Konisch"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rund-d50xh25cm-perlmutt-weiss",
        "label": "Pflanzkübel"
      }
    ]
  },
  "kirschlorbeer-im-kubel-sorten-pflege-uberwinterung": {
    "images": [
      {
        "match": "Pflanze wird mit",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "schwarz",
            "label": "Schwarz"
          },
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-anthrazit-metallic-quadratisch-50x50x50cm",
        "label": "Pflanzkübel"
      }
    ]
  },
  "tomaten-im-pflanzkuebel": {
    "images": [
      {
        "match": "Drei anthrazitfa",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "schwarz",
            "label": "Schwarz"
          },
          {
            "type": "collection",
            "handle": "rund-konisch",
            "label": "Rund Konisch"
          }
        ]
      },
      {
        "match": "Weisser runder P",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "rund-konisch",
            "label": "Rund Konisch"
          },
          {
            "type": "collection",
            "handle": "perlmuttweiss",
            "label": "Perlmuttweiß"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "collection",
        "handle": "rund-konisch",
        "label": "Rund Konisch"
      },
      {
        "type": "collection",
        "handle": "anthrazit-metallic",
        "label": "Anthrazit Metallic"
      }
    ]
  },
  "kraeuter-im-pflanzkuebel": {
    "images": [
      {
        "match": "Weisse eckige Pf",
        "type": "product",
        "handle": "pflanzkubel-fiberglas-quadratisch-30x30x30cm-perlmutt-weiss",
        "label": "Pflanzkübel"
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-saule-38x38x80cm-anthrazit-metallic",
        "label": "Pflanzkübel"
      }
    ]
  },
  "buchsbaum-im-pflanzkubel-pflege-schnitt-und-formgebung": {
    "images": [
      {
        "match": "Zwei Buchsbaumkugeln in großen a",
        "type": "collection",
        "handle": "rund-konisch",
        "label": "Rund Konisch"
      },
      {
        "match": "Zwei Buchsbaumkugeln in großen s",
        "type": "collection",
        "handle": "rund",
        "label": "Rund"
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rund-konisch-d60xh46-5cm-perlmutt-weiss",
        "label": "Pflanzkübel"
      }
    ]
  },
  "lavendel-im-pflanzkubel-standort-erde-pflege-und-uberwinterung": {
    "images": [
      {
        "match": "Große rechteckig",
        "items": [
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-rechteckig-anthrazit-metallic-120x50x55cm",
            "label": "Pflanzkübel"
          },
          {
            "type": "collection",
            "handle": "pflanzkubel-frostsicher-und-winterfest",
            "label": "Pflanzkübel frostsicher und winterfest"
          }
        ]
      },
      {
        "match": "Runder Pflanzküb",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "schwarz",
            "label": "Schwarz"
          },
          {
            "type": "collection",
            "handle": "rund-konisch",
            "label": "Rund Konisch"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-80x30x40cm-perlmutt-weiss",
        "label": "Pflanzkübel"
      }
    ]
  },
  "bambus-im-pflanzkuebel": {
    "images": [
      {
        "match": "Große rechteckig",
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-anthrazit-metallic-120x50x55cm",
        "label": "Pflanzkübel"
      },
      {
        "match": "Runder Pflanzküb",
        "type": "collection",
        "handle": "pflanzkubel-frostsicher-und-winterfest",
        "label": "Pflanzkübel frostsicher und winterfest"
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-anthrazit-metallic-100x40x50cm",
        "label": "Pflanzkübel"
      }
    ]
  },
  "pflanzkubel-fur-olivenbaum-grosse-material-uberwinterung": {
    "images": [
      {
        "match": "Pflanzkübel mit ",
        "items": [
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-quadratisch-50x50x50cm-elegant-schwarz-matt",
            "label": "Pflanzkübel"
          },
          {
            "type": "collection",
            "handle": "pflanzkubel-frostsicher-und-winterfest",
            "label": "Pflanzkübel frostsicher und winterfest"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-zylindrisch-d70xh60cm-anthrazit-metallic",
        "label": "Pflanzkübel"
      }
    ]
  },
  "graser-im-kubel-die-10-besten-sorten-fur-terrasse-balkon": {
    "images": [
      {
        "match": "Länglicher Pflan",
        "items": [
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-rechteckig-anthrazit-metallic-100x40x50cm",
            "label": "Pflanzkübel"
          },
          {
            "type": "collection",
            "handle": "pflanzkubel-frostsicher-und-winterfest",
            "label": "Pflanzkübel frostsicher und winterfest"
          }
        ]
      },
      {
        "match": "Zwei hohe Pflanz",
        "type": "product",
        "handle": "pflanzkubel-fiberglas-saule-38x38x100cm-anthrazit-metallic",
        "label": "Pflanzkübel"
      }
    ],
    "featured": [
      {
        "type": "collection",
        "handle": "anthrazit-metallic",
        "label": "Anthrazit Metallic"
      }
    ]
  },
  "ficus-lyrata-geigenfeige-pflegen": {
    "images": [
      {
        "match": "Geigenfeige (Ficus lyrata) i",
        "type": "product",
        "handle": "pflanzkubel-fiberglas-ball-d40xh32cm-hochglanz-rot",
        "label": "Pflanzkübel"
      },
      {
        "match": "Fingerprobe im T",
        "type": "collection",
        "handle": "hochglanz-weiss",
        "label": "Hochglanz Weiß"
      }
    ]
  },
  "monstera-deliciosa-pflegen": {
    "images": [
      {
        "match": "Monstera delicio",
        "type": "product",
        "handle": "pflanzkubel-fiberglas-saule-38x38x70cm-hochglanz-weiss",
        "label": "Pflanzkübel"
      },
      {
        "match": "Monstera als grü",
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-84x30x80cm-elegant-schwarz-matt",
        "label": "Pflanzkübel"
      }
    ]
  },
  "pflanzkuebel-quadratisch-tipps-ideen": {
    "images": [
      {
        "match": "Fünf quadratisch",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      },
      {
        "match": "Weiße quadratisc",
        "type": "product",
        "handle": "pflanzkubel-fiberglas-quadratisch-60x60x60cm-perlmutt-weiss",
        "label": "Pflanzkübel"
      },
      {
        "match": "Weißer quadratis",
        "type": "collection",
        "handle": "quadratisch",
        "label": "Quadratisch"
      }
    ],
    "featured": [
      {
        "type": "collection",
        "handle": "schwarz",
        "label": "Schwarz"
      },
      {
        "type": "collection",
        "handle": "quadratisch",
        "label": "Quadratisch"
      }
    ]
  },
  "pflanztrog-120x50x55-allrounder": {
    "images": [
      {
        "match": "Fiberglas-Pflanz",
        "items": [
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-rechteckig-anthrazit-metallic-120x50x55cm",
            "label": "Pflanzkübel"
          },
          {
            "type": "collection",
            "handle": "xxl",
            "label": "Pflanzkübel XXL"
          }
        ]
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-anthrazit-metallic-120x50x55cm",
        "label": "Pflanzkübel"
      },
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-120x50x55cm-grau",
        "label": "Pflanzkübel"
      },
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-120x50x55cm-elegant-schwarz-matt",
        "label": "Pflanzkübel"
      },
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-120x50x55cm-perlmutt-weiss",
        "label": "Pflanzkübel"
      }
    ]
  },
  "runde-pflanzenkuebel": {
    "images": [
      {
        "match": "Runder zylindris",
        "type": "collection",
        "handle": "zylinder",
        "label": "Zylinder"
      },
      {
        "match": "Weiße bauchige P",
        "type": "collection",
        "handle": "perlmuttweiss",
        "label": "Perlmuttweiß"
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-ball-d62xh48cm-hochglanz-rot",
        "label": "Pflanzkübel"
      }
    ]
  },
  "pflanzkuebel-gastronomie-hotel-buero": {
    "images": [
      {
        "match": "Großer schwarzer",
        "items": [
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-zylindrisch-d80xh70cm-schwarz-matt",
            "label": "Pflanzkübel"
          },
          {
            "type": "collection",
            "handle": "xxl",
            "label": "Pflanzkübel XXL"
          }
        ]
      },
      {
        "match": "Moderne Büroumge",
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-84x30x80cm-elegant-schwarz-matt",
        "label": "Pflanzkübel"
      }
    ],
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-84x30x80cm-anthrazit-metallic",
        "label": "Pflanzkübel"
      }
    ]
  },
  "fiberglas-vs-polyrattan-pflanzenkuebel-vergleich": {
    "images": [
      {
        "match": "Schwarze Pflanzk",
        "type": "collection",
        "handle": "saule",
        "label": "Säule"
      }
    ],
    "featured": [
      {
        "type": "collection",
        "handle": "fiberglas",
        "label": "Fiberglas"
      },
      {
        "type": "collection",
        "handle": "polyrattan",
        "label": "Polyrattan"
      }
    ]
  },
  "hortensien-im-kuebel": {
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-zylindrisch-d50xh50cm-grau",
        "label": "Pflanzkübel"
      }
    ]
  },
  "zz-pflanze-zamioculcas-pflegeleichtes-grun-fur-moderne-wohnraume": {
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-zylindrisch-d50xh50cm-schwarz-matt",
        "label": "Pflanzkübel"
      }
    ]
  },
  "troggarten-anlegen": {
    "featured": [
      {
        "type": "collection",
        "handle": "pflanztrog",
        "label": "Pflanztrog"
      },
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-60x25x30cm-perlmutt-weiss",
        "label": "Pflanzkübel"
      }
    ]
  },
  "pflanzkubel-grosse-berechnen": {
    "featured": [
      {
        "type": "collection",
        "handle": "pflanzkubel-nach-grosse",
        "label": "Pflanzkübel nach Größe"
      },
      {
        "type": "product",
        "handle": "pflanzkubel-rechteckig-anthrazit-metallic-60x25x30cm",
        "label": "Pflanzkübel"
      }
    ]
  },
  "pflanzen-grosse-pflanzkuebel-aussenbereich": {
    "featured": [
      {
        "type": "collection",
        "handle": "niedrig-quadratisch",
        "label": "Niedrig-Quadratisch"
      },
      {
        "type": "collection",
        "handle": "xxl",
        "label": "XXL"
      }
    ]
  },
  "pflanzkuebel-richtig-bepflanzen": {
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-rechteckig-100x25x25cm-perlmuttweiss",
        "label": "Pflanzkübel"
      }
    ]
  },
  "pflanzkuebel-winterfest-machen": {
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-saule-38x38x100cm-elegant-schwarz-matt",
        "label": "Pflanzkübel"
      }
    ]
  },
  "xxl-pflanzkubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "xxl",
        "label": "XXL Pflanzkübel"
      },
      {
        "type": "collection",
        "handle": "anthrazit",
        "label": "Anthrazit"
      }
    ]
  },
  "fiberglas-pflanzkubel-kaufberatung": {
    "featured": [
      {
        "type": "collection",
        "handle": "fiberglas",
        "label": "Fiberglas"
      },
      {
        "type": "collection",
        "handle": "pflanzkubel-fur-wohnraume",
        "label": "Für Wohnräume"
      }
    ]
  },
  "pampasgras-im-pflanzkubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "zylinder",
        "label": "Zylinder"
      }
    ]
  },
  "wandelroeschen-im-kubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "zylinder",
        "label": "Zylinder-Pflanzkübel"
      }
    ]
  },
  "wisteria-blauregen-im-pflanzkubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "pflanzkubel-frostsicher-und-winterfest",
        "label": "Frostsichere Pflanzkübel"
      }
    ]
  },
  "agapanthus-im-kubel": {
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-quadratisch-50x50x50cm-perlmutt-weiss",
        "label": "Perlmutt-Weiß Würfelkübel 50×50"
      }
    ],
    "images": [
      {
        "match": "Drei anthrazit",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratische Kübel"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-anthrazit-metallic-quadratisch-50x50x50cm",
            "label": "Anthrazit-Metallic 50×50"
          }
        ]
      }
    ]
  },
  "faecherahorn-im-kubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "pflanzkubel-frostsicher-und-winterfest",
        "label": "Kübel für winterharte Pflanzen"
      }
    ]
  },
  "hanfpalme-im-kubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "pflanzkubel-aussen",
        "label": "Wetterfeste Pflanzkübel"
      }
    ]
  },
  "kamelie-im-kubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "perlmuttweiss",
        "label": "Perlmuttweiße Pflanzkübel"
      }
    ]
  },
  "granatapfel-im-kubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "rund-konisch",
        "label": "Rund-konische Pflanzkübel"
      }
    ]
  },
  "feige-im-kubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "pflanzkubel-frostsicher-und-winterfest",
        "label": "Frostsichere Pflanzkübel"
      }
    ]
  },
  "oleander-im-kubel": {
    "featured": [
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-quadratisch-50x50x50cm-perlmutt-weiss",
        "label": "Perlmuttweißer Würfel 50×50"
      }
    ]
  },
  "kleine-terrasse-gestalten-pflanzkubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "saule",
        "label": "Säule"
      },
      {
        "type": "product",
        "handle": "pflanzkubel-fiberglas-saule-30x30x80cm-perlmuttweiss",
        "label": "Säule 30×30×80 perlmuttweiß"
      }
    ],
    "images": [
      {
        "match": "Kleine Terrasse mit Sitzbank, Blumenkasten und Olivenbäumchen im anthrazitfarbenen Rundkübel",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "rund-konisch",
            "label": "Rund Konisch"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      },
      {
        "match": "Hoher schmaler Pflanzkübel in Anthrazit mit Geigenfeige platzsparend in der Terrassenecke",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "saule",
            "label": "Säule"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      },
      {
        "match": "Drei weiße quadratische Pflanzkübel mit Federgras, Fetthenne und Lavendel auf kleiner Dachterrasse",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "collection",
            "handle": "perlmuttweiss",
            "label": "Perlmuttweiß"
          }
        ]
      }
    ]
  },
  "japandi-stil-mit-pflanzkubeln-japanischer-minimalismus-trifft-scandi": {
    "featured": [
      {
        "type": "collection",
        "handle": "niedrig-quadratisch",
        "label": "Niedrig-Quadratisch"
      },
      {
        "type": "collection",
        "handle": "schwarz",
        "label": "Schwarz"
      }
    ],
    "images": [
      {
        "match": "Japanischer Fächerahorn im anthrazitfarbenen Würfel-Pflanzkübel",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      },
      {
        "match": "Ufopflanze im anthrazitfarbenen Zylinder-Pflanzkübel auf rustikaler Holzbank im Japandi-Stil",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "zylinder",
            "label": "Zylinder"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      },
      {
        "match": "Bambus im anthrazitfarbenen Pflanztrog als Raumteiler im minimalistischen Japandi-Wohnraum",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "pflanztrog",
            "label": "Pflanztrog"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      },
      {
        "match": "Japandi-Innenhof mit drei anthrazitfarbenen Pflanztrögen mit Bambus vor Holzfassade und heller Putzwand",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "pflanztrog",
            "label": "Pflanztrog"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      }
    ]
  },
  "home-office-pflanzen-konzentration-produktivitat": {
    "featured": [
      {
        "type": "collection",
        "handle": "anthrazit-metallic",
        "label": "Anthrazit Metallic"
      },
      {
        "type": "collection",
        "handle": "quadratisch",
        "label": "Quadratisch"
      }
    ],
    "images": [
      {
        "match": "Strelitzie im anthrazitfarbenen Würfel-Pflanzkübel im hellen Home-Office mit Schreibtisch und Efeutute",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      },
      {
        "match": "Korbmarante im weißen Würfel-Pflanzkübel auf dem Schreibtisch neben Laptop und Kaffeetasse",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "perlmuttweiss",
            "label": "Perlmuttweiß"
          },
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          }
        ]
      },
      {
        "match": "Gummibaum im grauen Pflanztrog als Raumteiler zwischen Arbeitsplatz und Wohnbereich im Home-Office",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "pflanztrog",
            "label": "Pflanztrog"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          },
          {
            "type": "collection",
            "handle": "pflanzkubel-als-raumteiler",
            "label": "Pflanzkübel als Raumteiler"
          }
        ]
      }
    ]
  },
  "esszimmer-pflanzen-welche-pflanzen-passen": {
    "featured": [
      {
        "type": "collection",
        "handle": "schwarz",
        "label": "Schwarz"
      }
    ],
    "images": [
      {
        "match": "Basilikum, Thymian und Schnittlauch in drei schwarzen Zylinder-Pflanzkübeln auf dem Sideboard im Esszimmer",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "zylinder",
            "label": "Zylinder"
          },
          {
            "type": "collection",
            "handle": "schwarz",
            "label": "Schwarz"
          }
        ]
      }
    ]
  },
  "bienenfreundliche-pflanzen-im-pflanzkubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "pflanztrog",
        "label": "Pflanztrog"
      },
      {
        "type": "collection",
        "handle": "pflanzkubel-frostsicher-und-winterfest",
        "label": "Pflanzkübel frostsicher und winterfest"
      }
    ],
    "images": [
      {
        "match": "Lavendel, Salbei und Purpur-Sonnenhut in weißer Pflanzschale mit anfliegenden Honigbienen",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "pflanzschale",
            "label": "Pflanzschale"
          },
          {
            "type": "collection",
            "handle": "perlmuttweiss",
            "label": "Perlmuttweiß"
          }
        ]
      }
    ]
  },
  "erde-fuer-pflanzkubel-substrat": {
    "featured": [
      {
        "type": "collection",
        "handle": "pflanztrog",
        "label": "Pflanztrog"
      },
      {
        "type": "collection",
        "handle": "perlmuttweiss",
        "label": "Perlmuttweiß"
      },
      {
        "type": "collection",
        "handle": "xxl",
        "label": "XXL"
      }
    ],
    "images": [
      {
        "match": "Mineralische Substratmischung aus Lava, Bims und Blähton in Nahaufnahme mit jungen Keimlingen",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "fiberglas",
            "label": "Fiberglas"
          },
          {
            "type": "collection",
            "handle": "pflanzkubel-frostsicher-und-winterfest",
            "label": "Pflanzkübel frostsicher und winterfest"
          }
        ]
      }
    ]
  },
  "kubelpflanzen-umtopfen": {
    "featured": [
      {
        "type": "collection",
        "handle": "quadratisch",
        "label": "Quadratisch"
      },
      {
        "type": "collection",
        "handle": "pflanzkubel-frostsicher-und-winterfest",
        "label": "Pflanzkübel frostsicher und winterfest"
      }
    ],
    "images": [
      {
        "match": "Stark durchwurzelter Ballen einer Kübelpflanze als Zeichen, dass Umtopfen nötig ist",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "collection",
            "handle": "pflanztrog",
            "label": "Pflanztrog"
          }
        ]
      },
      {
        "match": "Kirschlorbeer vorher im engen Plastiktopf und nachher im anthrazitfarbenen Pflanztrog",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "pflanztrog",
            "label": "Pflanztrog"
          },
          {
            "type": "product",
            "handle": "pflanzkubel-fiberglas-rechteckig-anthrazit-metallic-100x40x50cm",
            "label": "Trog 100×40×50 anthrazit"
          }
        ]
      },
      {
        "match": "Frisches Substrat wird aus dem Sack in einen grauen Pflanztrog eingefüllt",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "pflanztrog",
            "label": "Pflanztrog"
          },
          {
            "type": "collection",
            "handle": "xxl",
            "label": "XXL"
          }
        ]
      }
    ]
  },
  "pflanzkubel-reinigen-pflegen": {
    "featured": [
      {
        "type": "collection",
        "handle": "anthrazit-metallic",
        "label": "Anthrazit Metallic"
      },
      {
        "type": "collection",
        "handle": "pflanztrog",
        "label": "Pflanztrog"
      }
    ],
    "images": [
      {
        "match": "Grünbelag wird von einem anthrazitfarbenen Würfel-Pflanzkübel abgewischt, halb gereinigte Fläche sichtbar",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          },
          {
            "type": "collection",
            "handle": "pflanzkubel-frostsicher-und-winterfest",
            "label": "Pflanzkübel frostsicher und winterfest"
          }
        ]
      },
      {
        "match": "Pflanzkübel wird mit weichem Mikrofasertuch und klarem Wasser schonend abgewischt",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "fiberglas",
            "label": "Fiberglas"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      },
      {
        "match": "Weiße Kalkränder am Rand eines anthrazitfarbenen Pflanztrogs mit Monstera in Nahaufnahme",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "pflanzkubel-frostsicher-und-winterfest",
            "label": "Pflanzkübel frostsicher und winterfest"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      }
    ]
  },
  "kubelpflanzen-schneiden": {
    "featured": [
      {
        "type": "collection",
        "handle": "anthrazit-metallic",
        "label": "Anthrazit Metallic"
      },
      {
        "type": "collection",
        "handle": "saule",
        "label": "Säule"
      }
    ],
    "images": [
      {
        "match": "Birkenfeige im anthrazitfarbenen Säulenkübel vor und nach dem Rückschnitt im Vergleich",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "saule",
            "label": "Säule"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      },
      {
        "match": "Licht aufgebauter japanischer Fächerahorn im anthrazitfarbenen Pflanzkübel nach dem Auslichten",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      },
      {
        "match": "Sauberer Schnitt dicht über einer Knospe an einem Magnolienzweig in Nahaufnahme",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "fiberglas",
            "label": "Fiberglas"
          },
          {
            "type": "collection",
            "handle": "pflanzkubel-frostsicher-und-winterfest",
            "label": "Pflanzkübel frostsicher und winterfest"
          }
        ]
      },
      {
        "match": "Saubere Bypass-Gartenschere und Pflanzkelle auf einem Holztisch vor Pflanztrögen",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "pflanztrog",
            "label": "Pflanztrog"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      },
      {
        "match": "Palme im anthrazitfarbenen Würfel-Pflanzkübel: Palmen dürfen nicht gekappt werden",
        "label": "Passende Kübel ansehen",
        "items": [
          {
            "type": "collection",
            "handle": "quadratisch",
            "label": "Quadratisch"
          },
          {
            "type": "collection",
            "handle": "anthrazit-metallic",
            "label": "Anthrazit Metallic"
          }
        ]
      }
    ]
  },
  "weinrebe-im-kubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "perlmuttweiss",
        "label": "Perlmuttweiße Pflanzkübel"
      }
    ]
  },
  "lampenputzergras-im-kubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "quadratisch",
        "label": "Quadratische Pflanzkübel"
      }
    ]
  },
  "felsenbirne-im-kubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "grosse-pflanzkubel-fur-winterharte-pflanzen",
        "label": "Große Kübel für winterharte Pflanzen"
      }
    ]
  },
  "chinaschilf-im-kubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "zylinder",
        "label": "Zylindrische Pflanzkübel"
      }
    ]
  },
  "brombeere-im-kubel": {
    "featured": [
      {
        "type": "collection",
        "handle": "pflanzkubel-frostsicher-und-winterfest",
        "label": "Frostsichere Pflanzkübel"
      }
    ]
  }
};
